import { useRef, useState, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { NotificationManager } from 'react-notifications';

export default function useExcelExportLite(exportAction, { buildQuery } = {}) {
    const dispatch = useDispatch();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const lock = useRef(false);

    const query = useMemo(
        () => (buildQuery ? buildQuery() : qs.parse(location.search.slice(1))),
        [buildQuery, location.search]
    );

    const queueExcelExport = useCallback(() => {
        if (lock.current) return;
        lock.current = true;
        setLoading(true);

        // Thông báo ngay, export chạy nền (tránh timeout UI)
        NotificationManager.success(
            'Quá trình xuất file đang được thực hiện. Vui lòng kiểm tra email của bạn sau ít phút.',
            'Thông báo',
            9000
        );

        // Không await: fire-and-forget + bắt lỗi nền
        dispatch(exportAction(query))
            .catch(() => {
                NotificationManager.error('Không thể khởi tạo xuất file. Vui lòng thử lại.', 'Lỗi');
            })
            .finally(() => {
                setLoading(false);
                lock.current = false;
            });
    }, [dispatch, exportAction, query]);

    return [loading, queueExcelExport];
}
